/*
 * @Author: jiangxd
 * @Date: 2021-05-19 20:12:59
 * @LastEditTime: 2021-09-16 15:31:16
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/main.ts
 */

import Vue from 'vue';
import Quill from 'quill';
import draggable from 'vuedraggable';
import ElementUI from 'element-ui';
import VueSocketIo from 'vue-socket.io';
import VueQuillEditor from 'vue-quill-editor';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueClipboard from 'vue-clipboard2';

import { ImageDrop } from 'quill-image-drop-module'; // quill图片可拖拽上传
import { globalElement } from './library/utils/globalElement';

import router from './router';
import App from './App.vue';
import store from './store';

import { setMessage } from './views/components/message';
import dialogDragInstall from './util/el-dragable-dialog';
import encryptInstall from './util/el-open-encrypt';
import ImageResize from '@/library/quill/quillImageResize/ImageResize'; // 调整图片大小组件。
// import { ImageResize } from "quill-image-resize-module";

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import 'swiper/dist/css/swiper.css';
import 'element-ui/lib/theme-chalk/index.css';

import { appEnvConfig } from '@/configs/appConfigs';

Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/resizeImage ', ImageResize);

Vue.component('Draggable', draggable);

Vue.use(ElementUI);

Vue.use(VueAwesomeSwiper /* { default global options } */);

Vue.use(VueClipboard);
Vue.use(dialogDragInstall);
Vue.use(encryptInstall);

Vue.use(VueQuillEditor);

console.log('app env config', appEnvConfig);

Vue.use(
  new VueSocketIo({
    debug: true,
    connection: appEnvConfig.socketUrl, // 暂时仅限开发环境
  }),
);

Vue.config.productionTip = false;

// entity of Vue
const Vm = new Vue({
  router,
  store,
  watch: {
    $route() {
      localStorage.removeItem('curpage'); // 恢复相关页面的二级tab名称
      localStorage.removeItem('curTab'); // 恢复每个页面的二级tab
      localStorage.removeItem('curPageName'); // 恢复相关页面的二级tab名称
    },
  },
   // @ts-expect-error
  sockets: {
    // 查看socket是否渲染成功
    connect() {
      console.log('链接成功');
      this.$emit('socket', 3);
    },
    connect_failed() {
      console.log('连接失败');
      this.$emit('socket', 2);
    },
    disconnect() {
      console.log('断开链接');
      this.$emit('socket', 0);
    }, // 检测socket断开链接
    reconnect() {
      console.log('重新链接');
      this.$emit('socket', 6);
    },
  },
  render: (h) => {
    return h(App);
  },
}).$mount('#app');

Vm.$message = setMessage();
Vm.$stringify = JSON.stringify;
Vm.$parse = JSON.parse;

globalElement.message = Vm.$message;
globalElement.Vm = Vm;
